export const Captions = {
  upload: 'Adding Data',
  split: 'Splitting Data',
  tiling: 'Tiling Data',
  edit: 'Preparing Data for Editing',
  revert: 'Reverting dataset... please wait',
  delete: 'Deleting dataset... please wait',
};
